module.exports = __webpack_public_path__ + "static/magic-52c84fad8857d3c050ad11b5f289b494.jpg";